<template>
    <div v-loading="loading">
        <el-form class="form" label-width="110px" ref="ruleForm" :model="form" :rules="rules">
            <el-form-item label="是否推送：" prop="pushSwitch">
                <el-switch
                        v-model="form.pushSwitch"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="推送"
                        inactive-text="不推送"/>
            </el-form-item>
            <el-form-item label="发送用户：" prop="sendType">
                <el-select v-model="form.sendType">
                    <el-option
                            v-for="item of sendTypeOptions"
                            :key="item.label"
                            :label="item.label"
                            :value="item.value"/>
                </el-select>
            </el-form-item>
            <el-form-item v-show="form.sendType === 2" prop="sendToRandomIds">
                <el-input
                        v-model="form.sendToRandomIds"
                        type="textarea"
                        resize="none"
                        placeholder="请输入用户ID，多个用 ' , ' 分隔"/>
            </el-form-item>
            <el-form-item label="简体中文：" prop="zhContent">
                <el-input
                        v-model="form.zhContent"
                        type="textarea"
                        resize="none"
                        placeholder="请输入系统消息内容"/>
            </el-form-item>
            <el-form-item label="繁体中文：" prop="hkContent">
                <el-input
                        v-model="form.hkContent"
                        type="textarea"
                        resize="none"
                        placeholder="請輸入系統消息內容"/>
            </el-form-item>
            <el-form-item label="英文：" prop="usContent">
                <el-input
                        v-model="form.usContent"
                        type="textarea"
                        resize="none"
                        placeholder="Please input the message content"/>
            </el-form-item>
            <el-form-item label="发送时间：" prop="sendTimeType">
                <el-select v-model="form.sendTimeType">
                    <el-option
                            v-for="item of sendTimeTypeOptions"
                            :key="item.label"
                            :label="item.label"
                            :value="item.value"/>
                </el-select>
            </el-form-item>
            <el-form-item v-show="form.sendTimeType === 2" prop="sentTime">
                <el-date-picker
                        v-model="form.sentTime"
                        type="datetime"
                        value-format="timestamp"
                        placeholder="选择日期时间"/>
            </el-form-item>
            <div class="footer">
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import {roomPathOptions} from 'mixins'

    export default {
        mixins: [roomPathOptions],
        data() {
            return {
                loading:false,
                sendTypeOptions: [
                    {label: '全服', value: 1},
                    {label: '指定用户', value: 2}
                ],
                sendTimeTypeOptions: [
                    {label: '立即发送', value: 1},
                    {label: '定时发送', value: 2}
                ],
                form: {
                    sendType: 1,
                    sendToRandomIds: '',
                    pushSwitch: 0,
                    zhContent: '',// 简体
                    hkContent: '',// 繁体
                    usContent: '',// 英文
                    sendTimeType: 1,
                    sentTime: '',
                },
                rules: {
                    sendToRandomIds: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.form.sendType === 2 && !value) {
                                    callback(new Error('请输入用户ID'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    zhContent: [
                        {required: true, message: '请输入系统消息内容', trigger: 'blur'}
                    ],
                    hkContent: [
                        {required: true, message: '请输入系统消息内容', trigger: 'blur'}
                    ],
                    usContent: [
                        {required: true, message: '请输入系统消息内容', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            ...mapActions('system', ['sendSysMessage']),
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let params = Object.assign({},this.form,{
                            sendToRandomIds:this.form.sendToRandomIds.split(',')
                        });
                        this.sendSysMessage(params).then(() => {
                            this.loading = false;
                            this.$message.success('请求成功');
                            this.$refs[formName].resetFields();
                        })
                    }
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translateX(-50%);
        width: 500px;

        :global(.el-date-editor) {
            width: 100% !important;
        }
        :global(.el-select) {
            width: 100%;
        }
    }

    .footer {
        padding: 20px 0 0 100px;
        text-align: center;
        :global(.el-button) {
            width: 150px;
            margin-bottom: 20px;
        }
    }
</style>